<template>
  <footer>
    <div class="container">
      <div class="logo-wrap">
        <img alt="">
        <span>«Учебно-методический центр ФАС России», 2021</span>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>

<style scoped lang="scss">
  footer {
    //background-color: #F2F5F7;
    padding: 35px 0;
    color: #808080;
    font-size: 13px;
    @media screen and (max-width: 500px){
      padding: 20px 0;
    }
    .container{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
    }
    .logo-wrap {
      white-space: nowrap;
      img{
        height: 52px;
        margin-right: 20px;
      }
      img, span{
        display: inline-block;
        vertical-align: middle;
      }
    }
    .right {
      @media screen and (max-width: 500px){
        width: 100%;
        text-align: center;
        margin-top: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue